import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-vertical-radio[formGroup][propertyName][radioData]',
  templateUrl: './vertical-radio.component.html',
  styles: [],
  standalone: false,
})
export class VerticalRadioComponent extends BaseFormComponent {

  @Input() radioData: RadioBtnData[];
  @Input() FIELD_SPACING: number
  @Output() userInput? = new EventEmitter<string>();
  
  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  userAction(input: string) {
    this.userInput.emit(input);
  }
}

export interface RadioBtnData {
  value: string;
  label: string;
}
